/**
 * Report Service
 * PDD 報告 API 服務
 */

import axios from '../api/axios';

export interface SectionCompleteness {
  key: string;
  label_zh: string;
  label_en: string;
  percentage: number;
  has_data: boolean;
}

export interface CompletenessData {
  project_id: number;
  project_title: string;
  pdd_no: string | null;
  sections: SectionCompleteness[];
  overall_percentage: number;
}

const BASE_URL = '/api/report';

export const getCompleteness = async (projectId: number): Promise<CompletenessData> => {
  const res = await axios.get<CompletenessData>(`${BASE_URL}/completeness/${projectId}`);
  return res.data;
};

export const getHtmlReport = async (projectId: number): Promise<string> => {
  const res = await axios.get<string>(`${BASE_URL}/html/${projectId}`, {
    responseType: 'text',
  });
  return res.data;
};

export const downloadPdfReport = async (projectId: number, filename: string): Promise<void> => {
  const res = await axios.get(`${BASE_URL}/pdf/${projectId}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default { getCompleteness, getHtmlReport, downloadPdfReport };
